/**
 * The coarse OS family and major version, for diagnostics.
 *
 * One source of truth for two callers: the anonymous analytics' `os_version` and the
 * `X-MeetFolks-Build` header's `os` key (#980), so a build and its events name the OS
 * the same way. It is the family, plus the major version only where the user agent
 * reports it truthfully -- iOS, iPadOS and Android. Desktop browsers freeze their OS
 * version in the user agent, so they report the family alone. Anything unrecognised is
 * `other`; the header omits the `os` key then rather than sending a guess.
 *
 * Plain JS like the rest of `lib/`, so it stays runnable outside the bundle.
 */
export function osVersionFromUserAgent(userAgent) {
  const apple = /\b(iPhone|iPad|iPod)\b.*? OS (\d{1,3})_/.exec(userAgent);
  if (apple) return `${apple[1] === "iPad" ? "iPadOS" : "iOS"} ${apple[2]}`;
  const android = /\bAndroid (\d{1,3})\b/.exec(userAgent);
  if (android) return `Android ${android[1]}`;
  if (/\bCrOS\b/.test(userAgent)) return "ChromeOS";
  if (/\bMacintosh\b|\bMac OS X\b/.test(userAgent)) return "macOS";
  if (/\bWindows\b/.test(userAgent)) return "Windows";
  if (/\bLinux\b/.test(userAgent)) return "Linux";
  return "other";
}
